import CustomScalars from '../scalars'
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  EnvInfo: { input: CustomScalars.EnvInfo; output: CustomScalars.EnvInfo; }
  MetaData: { input: CustomScalars.MetaData; output: CustomScalars.MetaData; }
  QuestionStats: { input: CustomScalars.QuestionStats; output: CustomScalars.QuestionStats; }
  SimilarQuestions: { input: CustomScalars.SimilarQuestions; output: CustomScalars.SimilarQuestions; }
};

export type ActiveDailyCodingChallengeQuestion = {
  __typename?: 'ActiveDailyCodingChallengeQuestion';
  date: Scalars['String']['output'];
  link: Scalars['String']['output'];
  question: Question;
  userStatus: UserStatus;
};

export type Article = {
  __typename?: 'Article';
  canSeeDetail: Scalars['Boolean']['output'];
  hasVideoSolution: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  paidOnly: Scalars['Boolean']['output'];
  paidOnlyVideo: Scalars['Boolean']['output'];
};

export type ChallengeQuestion = {
  __typename?: 'ChallengeQuestion';
  date: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  incompleteChallengeCount: Scalars['Int']['output'];
  streakCount: Scalars['Int']['output'];
  type: ChallengeType;
};

export enum ChallengeType {
  Daily = 'DAILY'
}

export type CodeSnippet = {
  __typename?: 'CodeSnippet';
  code: Scalars['String']['output'];
  lang: Scalars['String']['output'];
  langSlug: Scalars['String']['output'];
};

export enum Difficulty {
  All = 'All',
  Easy = 'Easy',
  Hard = 'Hard',
  Medium = 'Medium'
}

export enum JudgeType {
  Large = 'large'
}

export type Me = {
  __typename?: 'Me';
  activeSessionId: Scalars['Int']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isMockUser?: Maybe<Scalars['Boolean']['output']>;
  isPremium?: Maybe<Scalars['Boolean']['output']>;
  isSignedIn?: Maybe<Scalars['Boolean']['output']>;
  isSuperuser?: Maybe<Scalars['Boolean']['output']>;
  isTranslator?: Maybe<Scalars['Boolean']['output']>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  notificationStatus?: Maybe<NotificationStatus>;
  permissions: Array<Maybe<Scalars['String']['output']>>;
  userId?: Maybe<Scalars['Int']['output']>;
  username: Scalars['String']['output'];
};

export type NotificationStatus = {
  __typename?: 'NotificationStatus';
  lastModified: Scalars['Int']['output'];
  numUnread: Scalars['Int']['output'];
};

export type Profile = {
  __typename?: 'Profile';
  ranking?: Maybe<Scalars['Int']['output']>;
  reputation?: Maybe<Scalars['Int']['output']>;
  starRating?: Maybe<Scalars['Int']['output']>;
  userAvatar?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  activeDailyCodingChallengeQuestion: ActiveDailyCodingChallengeQuestion;
  allQuestionsCount: Array<QuestionCount>;
  matchedUser: User;
  question: Question;
  userStatus: Me;
};


export type QueryMatchedUserArgs = {
  username?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQuestionArgs = {
  titleSlug?: InputMaybe<Scalars['String']['input']>;
};

export type Question = {
  __typename?: 'Question';
  acRate: Scalars['Float']['output'];
  adminUrl?: Maybe<Scalars['String']['output']>;
  boundTopicId?: Maybe<Scalars['Int']['output']>;
  categoryTitle: Scalars['String']['output'];
  challengeQuestion: ChallengeQuestion;
  codeSnippets: Array<CodeSnippet>;
  companyTagStats?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  contributors: Array<User>;
  difficulty: Difficulty;
  dislikes: Scalars['Int']['output'];
  enableDebugger: Scalars['Boolean']['output'];
  enableRunCode: Scalars['Boolean']['output'];
  enableTestMode: Scalars['Boolean']['output'];
  envInfo: Scalars['EnvInfo']['output'];
  exampleTestcases: Scalars['String']['output'];
  freqBar?: Maybe<Scalars['Int']['output']>;
  hasSolution: Scalars['Boolean']['output'];
  hasVideoSolution: Scalars['Boolean']['output'];
  hints: Array<Scalars['String']['output']>;
  isFavor: Scalars['Boolean']['output'];
  isLiked?: Maybe<Scalars['Boolean']['output']>;
  isPaidOnly: Scalars['Boolean']['output'];
  judgeType: JudgeType;
  judgerAvailable: Scalars['Boolean']['output'];
  libraryUrl?: Maybe<Scalars['String']['output']>;
  likes: Scalars['Int']['output'];
  metaData: Scalars['MetaData']['output'];
  mysqlSchemas: Array<Scalars['String']['output']>;
  questionFrontendId: Scalars['Int']['output'];
  questionId: Scalars['Int']['output'];
  sampleTestCase: Scalars['String']['output'];
  similarQuestions: Array<Scalars['SimilarQuestions']['output']>;
  solution: Article;
  stats: Scalars['QuestionStats']['output'];
  status?: Maybe<QuestionStatus>;
  title: Scalars['String']['output'];
  titleSlug: Scalars['String']['output'];
  topicTags: Array<TopicTag>;
  translatedContent?: Maybe<Scalars['String']['output']>;
  translatedTitle?: Maybe<Scalars['String']['output']>;
};

export type QuestionCount = Stats & {
  __typename?: 'QuestionCount';
  count: Scalars['Int']['output'];
  difficulty: Difficulty;
};

export enum QuestionStatus {
  Ac = 'ac'
}

export type Stats = {
  count: Scalars['Int']['output'];
  difficulty: Difficulty;
};

export type SubmissionNum = Stats & {
  __typename?: 'SubmissionNum';
  count: Scalars['Int']['output'];
  difficulty: Difficulty;
  submissions: Scalars['Int']['output'];
};

export type SubmitStats = {
  __typename?: 'SubmitStats';
  acSubmissionNum: Array<SubmissionNum>;
  totalSubmissionNum: Array<SubmissionNum>;
};

export type TopicTag = {
  __typename?: 'TopicTag';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  translatedName?: Maybe<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  profile: Profile;
  profileUrl?: Maybe<Scalars['String']['output']>;
  submitStats: SubmitStats;
  username: Scalars['String']['output'];
};

export enum UserStatus {
  NotStart = 'NotStart'
}

export type GetMinimalQuestionDataQueryVariables = Exact<{
  titleSlug: Scalars['String']['input'];
}>;


export type GetMinimalQuestionDataQuery = (
  { __typename?: 'Query' }
  & { question: (
    { __typename?: 'Question' }
    & Pick<Question, 'title' | 'titleSlug' | 'difficulty'>
  ) }
);

export type QuestionDataQueryVariables = Exact<{
  titleSlug: Scalars['String']['input'];
}>;


export type QuestionDataQuery = (
  { __typename?: 'Query' }
  & { question: (
    { __typename: 'Question' }
    & Pick<Question, 'questionId' | 'questionFrontendId' | 'boundTopicId' | 'title' | 'titleSlug' | 'content' | 'translatedTitle' | 'translatedContent' | 'isPaidOnly' | 'difficulty' | 'likes' | 'dislikes' | 'isLiked' | 'similarQuestions' | 'exampleTestcases' | 'categoryTitle' | 'companyTagStats' | 'stats' | 'hints' | 'status' | 'sampleTestCase' | 'metaData' | 'judgerAvailable' | 'judgeType' | 'mysqlSchemas' | 'enableRunCode' | 'enableTestMode' | 'enableDebugger' | 'envInfo' | 'libraryUrl' | 'adminUrl'>
    & { contributors: Array<(
      { __typename: 'User' }
      & Pick<User, 'username' | 'profileUrl' | 'avatarUrl'>
    )>, topicTags: Array<(
      { __typename: 'TopicTag' }
      & Pick<TopicTag, 'name' | 'slug' | 'translatedName'>
    )>, codeSnippets: Array<(
      { __typename: 'CodeSnippet' }
      & Pick<CodeSnippet, 'lang' | 'langSlug' | 'code'>
    )>, solution: (
      { __typename: 'Article' }
      & Pick<Article, 'id' | 'canSeeDetail' | 'paidOnly' | 'hasVideoSolution' | 'paidOnlyVideo'>
    ), challengeQuestion: (
      { __typename: 'ChallengeQuestion' }
      & Pick<ChallengeQuestion, 'id' | 'date' | 'incompleteChallengeCount' | 'streakCount' | 'type'>
    ) }
  ) }
);

export type QuestionOfTodayQueryVariables = Exact<{ [key: string]: never; }>;


export type QuestionOfTodayQuery = (
  { __typename?: 'Query' }
  & { activeDailyCodingChallengeQuestion: (
    { __typename?: 'ActiveDailyCodingChallengeQuestion' }
    & Pick<ActiveDailyCodingChallengeQuestion, 'date' | 'userStatus' | 'link'>
    & { question: (
      { __typename?: 'Question' }
      & Pick<Question, 'acRate' | 'difficulty' | 'freqBar' | 'isFavor' | 'status' | 'title' | 'titleSlug' | 'hasVideoSolution' | 'hasSolution'>
      & { frontendQuestionId: Question['questionFrontendId'], paidOnly: Question['isPaidOnly'] }
      & { topicTags: Array<(
        { __typename?: 'TopicTag' }
        & Pick<TopicTag, 'name' | 'id' | 'slug'>
      )> }
    ) }
  ) }
);

export type GetUserProfileQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type GetUserProfileQuery = (
  { __typename?: 'Query' }
  & { allQuestionsCount: Array<(
    { __typename?: 'QuestionCount' }
    & Pick<QuestionCount, 'difficulty' | 'count'>
  )>, matchedUser: (
    { __typename?: 'User' }
    & { submitStats: (
      { __typename?: 'SubmitStats' }
      & { acSubmissionNum: Array<(
        { __typename?: 'SubmissionNum' }
        & Pick<SubmissionNum, 'difficulty' | 'count' | 'submissions'>
      )>, totalSubmissionNum: Array<(
        { __typename?: 'SubmissionNum' }
        & Pick<SubmissionNum, 'difficulty' | 'count' | 'submissions'>
      )> }
    ), profile: (
      { __typename?: 'Profile' }
      & Pick<Profile, 'ranking' | 'reputation' | 'starRating' | 'userAvatar'>
    ) }
  ) }
);

export type GlobalDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalDataQuery = (
  { __typename?: 'Query' }
  & { userStatus: (
    { __typename?: 'Me' }
    & Pick<Me, 'userId' | 'isSignedIn' | 'isMockUser' | 'isPremium' | 'isVerified' | 'username' | 'avatar' | 'isAdmin' | 'isSuperuser' | 'permissions' | 'isTranslator' | 'activeSessionId'>
    & { notificationStatus?: Maybe<(
      { __typename?: 'NotificationStatus' }
      & Pick<NotificationStatus, 'lastModified' | 'numUnread'>
    )> }
  ) }
);

export type QuestionTitleQueryVariables = Exact<{
  titleSlug: Scalars['String']['input'];
}>;


export type QuestionTitleQuery = (
  { __typename?: 'Query' }
  & { question: (
    { __typename?: 'Question' }
    & Pick<Question, 'questionId' | 'questionFrontendId' | 'title' | 'titleSlug' | 'isPaidOnly' | 'difficulty' | 'likes' | 'dislikes' | 'categoryTitle'>
  ) }
);


export const GetMinimalQuestionDataDocument = gql`
    query GetMinimalQuestionData($titleSlug: String!) {
  question(titleSlug: $titleSlug) {
    title
    titleSlug
    difficulty
  }
}
    `;

/**
 * __useGetMinimalQuestionDataQuery__
 *
 * To run a query within a React component, call `useGetMinimalQuestionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMinimalQuestionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMinimalQuestionDataQuery({
 *   variables: {
 *      titleSlug: // value for 'titleSlug'
 *   },
 * });
 */
export function useGetMinimalQuestionDataQuery(baseOptions: Apollo.QueryHookOptions<GetMinimalQuestionDataQuery, GetMinimalQuestionDataQueryVariables> & ({ variables: GetMinimalQuestionDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMinimalQuestionDataQuery, GetMinimalQuestionDataQueryVariables>(GetMinimalQuestionDataDocument, options);
      }
export function useGetMinimalQuestionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMinimalQuestionDataQuery, GetMinimalQuestionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMinimalQuestionDataQuery, GetMinimalQuestionDataQueryVariables>(GetMinimalQuestionDataDocument, options);
        }
// @ts-ignore
export function useGetMinimalQuestionDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMinimalQuestionDataQuery, GetMinimalQuestionDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetMinimalQuestionDataQuery, GetMinimalQuestionDataQueryVariables>;
export function useGetMinimalQuestionDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMinimalQuestionDataQuery, GetMinimalQuestionDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetMinimalQuestionDataQuery | undefined, GetMinimalQuestionDataQueryVariables>;
export function useGetMinimalQuestionDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMinimalQuestionDataQuery, GetMinimalQuestionDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMinimalQuestionDataQuery, GetMinimalQuestionDataQueryVariables>(GetMinimalQuestionDataDocument, options);
        }
export type GetMinimalQuestionDataQueryHookResult = ReturnType<typeof useGetMinimalQuestionDataQuery>;
export type GetMinimalQuestionDataLazyQueryHookResult = ReturnType<typeof useGetMinimalQuestionDataLazyQuery>;
export type GetMinimalQuestionDataSuspenseQueryHookResult = ReturnType<typeof useGetMinimalQuestionDataSuspenseQuery>;
export type GetMinimalQuestionDataQueryResult = Apollo.QueryResult<GetMinimalQuestionDataQuery, GetMinimalQuestionDataQueryVariables>;
export const QuestionDataDocument = gql`
    query questionData($titleSlug: String!) {
  question(titleSlug: $titleSlug) {
    questionId
    questionFrontendId
    boundTopicId
    title
    titleSlug
    content
    translatedTitle
    translatedContent
    isPaidOnly
    difficulty
    likes
    dislikes
    isLiked
    similarQuestions
    exampleTestcases
    categoryTitle
    contributors {
      username
      profileUrl
      avatarUrl
      __typename
    }
    topicTags {
      name
      slug
      translatedName
      __typename
    }
    companyTagStats
    codeSnippets {
      lang
      langSlug
      code
      __typename
    }
    stats
    hints
    solution {
      id
      canSeeDetail
      paidOnly
      hasVideoSolution
      paidOnlyVideo
      __typename
    }
    status
    sampleTestCase
    metaData
    judgerAvailable
    judgeType
    mysqlSchemas
    enableRunCode
    enableTestMode
    enableDebugger
    envInfo
    libraryUrl
    adminUrl
    challengeQuestion {
      id
      date
      incompleteChallengeCount
      streakCount
      type
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useQuestionDataQuery__
 *
 * To run a query within a React component, call `useQuestionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionDataQuery({
 *   variables: {
 *      titleSlug: // value for 'titleSlug'
 *   },
 * });
 */
export function useQuestionDataQuery(baseOptions: Apollo.QueryHookOptions<QuestionDataQuery, QuestionDataQueryVariables> & ({ variables: QuestionDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionDataQuery, QuestionDataQueryVariables>(QuestionDataDocument, options);
      }
export function useQuestionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionDataQuery, QuestionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionDataQuery, QuestionDataQueryVariables>(QuestionDataDocument, options);
        }
// @ts-ignore
export function useQuestionDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QuestionDataQuery, QuestionDataQueryVariables>): Apollo.UseSuspenseQueryResult<QuestionDataQuery, QuestionDataQueryVariables>;
export function useQuestionDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionDataQuery, QuestionDataQueryVariables>): Apollo.UseSuspenseQueryResult<QuestionDataQuery | undefined, QuestionDataQueryVariables>;
export function useQuestionDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionDataQuery, QuestionDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionDataQuery, QuestionDataQueryVariables>(QuestionDataDocument, options);
        }
export type QuestionDataQueryHookResult = ReturnType<typeof useQuestionDataQuery>;
export type QuestionDataLazyQueryHookResult = ReturnType<typeof useQuestionDataLazyQuery>;
export type QuestionDataSuspenseQueryHookResult = ReturnType<typeof useQuestionDataSuspenseQuery>;
export type QuestionDataQueryResult = Apollo.QueryResult<QuestionDataQuery, QuestionDataQueryVariables>;
export const QuestionOfTodayDocument = gql`
    query questionOfToday {
  activeDailyCodingChallengeQuestion {
    date
    userStatus
    link
    question {
      acRate
      difficulty
      freqBar
      frontendQuestionId: questionFrontendId
      isFavor
      paidOnly: isPaidOnly
      status
      title
      titleSlug
      hasVideoSolution
      hasSolution
      topicTags {
        name
        id
        slug
      }
    }
  }
}
    `;

/**
 * __useQuestionOfTodayQuery__
 *
 * To run a query within a React component, call `useQuestionOfTodayQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionOfTodayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionOfTodayQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuestionOfTodayQuery(baseOptions?: Apollo.QueryHookOptions<QuestionOfTodayQuery, QuestionOfTodayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionOfTodayQuery, QuestionOfTodayQueryVariables>(QuestionOfTodayDocument, options);
      }
export function useQuestionOfTodayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionOfTodayQuery, QuestionOfTodayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionOfTodayQuery, QuestionOfTodayQueryVariables>(QuestionOfTodayDocument, options);
        }
// @ts-ignore
export function useQuestionOfTodaySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QuestionOfTodayQuery, QuestionOfTodayQueryVariables>): Apollo.UseSuspenseQueryResult<QuestionOfTodayQuery, QuestionOfTodayQueryVariables>;
export function useQuestionOfTodaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionOfTodayQuery, QuestionOfTodayQueryVariables>): Apollo.UseSuspenseQueryResult<QuestionOfTodayQuery | undefined, QuestionOfTodayQueryVariables>;
export function useQuestionOfTodaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionOfTodayQuery, QuestionOfTodayQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionOfTodayQuery, QuestionOfTodayQueryVariables>(QuestionOfTodayDocument, options);
        }
export type QuestionOfTodayQueryHookResult = ReturnType<typeof useQuestionOfTodayQuery>;
export type QuestionOfTodayLazyQueryHookResult = ReturnType<typeof useQuestionOfTodayLazyQuery>;
export type QuestionOfTodaySuspenseQueryHookResult = ReturnType<typeof useQuestionOfTodaySuspenseQuery>;
export type QuestionOfTodayQueryResult = Apollo.QueryResult<QuestionOfTodayQuery, QuestionOfTodayQueryVariables>;
export const GetUserProfileDocument = gql`
    query getUserProfile($username: String!) {
  allQuestionsCount {
    difficulty
    count
  }
  matchedUser(username: $username) {
    submitStats {
      acSubmissionNum {
        difficulty
        count
        submissions
      }
      totalSubmissionNum {
        difficulty
        count
        submissions
      }
    }
    profile {
      ranking
      reputation
      starRating
      userAvatar
    }
  }
}
    `;

/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetUserProfileQuery(baseOptions: Apollo.QueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables> & ({ variables: GetUserProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
      }
export function useGetUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
// @ts-ignore
export function useGetUserProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserProfileQuery, GetUserProfileQueryVariables>;
export function useGetUserProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserProfileQuery | undefined, GetUserProfileQueryVariables>;
export function useGetUserProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
export type GetUserProfileQueryHookResult = ReturnType<typeof useGetUserProfileQuery>;
export type GetUserProfileLazyQueryHookResult = ReturnType<typeof useGetUserProfileLazyQuery>;
export type GetUserProfileSuspenseQueryHookResult = ReturnType<typeof useGetUserProfileSuspenseQuery>;
export type GetUserProfileQueryResult = Apollo.QueryResult<GetUserProfileQuery, GetUserProfileQueryVariables>;
export const GlobalDataDocument = gql`
    query globalData {
  userStatus {
    userId
    isSignedIn
    isMockUser
    isPremium
    isVerified
    username
    avatar
    isAdmin
    isSuperuser
    permissions
    isTranslator
    activeSessionId
    notificationStatus {
      lastModified
      numUnread
    }
  }
}
    `;

/**
 * __useGlobalDataQuery__
 *
 * To run a query within a React component, call `useGlobalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalDataQuery(baseOptions?: Apollo.QueryHookOptions<GlobalDataQuery, GlobalDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalDataQuery, GlobalDataQueryVariables>(GlobalDataDocument, options);
      }
export function useGlobalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalDataQuery, GlobalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalDataQuery, GlobalDataQueryVariables>(GlobalDataDocument, options);
        }
// @ts-ignore
export function useGlobalDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GlobalDataQuery, GlobalDataQueryVariables>): Apollo.UseSuspenseQueryResult<GlobalDataQuery, GlobalDataQueryVariables>;
export function useGlobalDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GlobalDataQuery, GlobalDataQueryVariables>): Apollo.UseSuspenseQueryResult<GlobalDataQuery | undefined, GlobalDataQueryVariables>;
export function useGlobalDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GlobalDataQuery, GlobalDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GlobalDataQuery, GlobalDataQueryVariables>(GlobalDataDocument, options);
        }
export type GlobalDataQueryHookResult = ReturnType<typeof useGlobalDataQuery>;
export type GlobalDataLazyQueryHookResult = ReturnType<typeof useGlobalDataLazyQuery>;
export type GlobalDataSuspenseQueryHookResult = ReturnType<typeof useGlobalDataSuspenseQuery>;
export type GlobalDataQueryResult = Apollo.QueryResult<GlobalDataQuery, GlobalDataQueryVariables>;
export const QuestionTitleDocument = gql`
    query questionTitle($titleSlug: String!) {
  question(titleSlug: $titleSlug) {
    questionId
    questionFrontendId
    title
    titleSlug
    isPaidOnly
    difficulty
    likes
    dislikes
    categoryTitle
  }
}
    `;

/**
 * __useQuestionTitleQuery__
 *
 * To run a query within a React component, call `useQuestionTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionTitleQuery({
 *   variables: {
 *      titleSlug: // value for 'titleSlug'
 *   },
 * });
 */
export function useQuestionTitleQuery(baseOptions: Apollo.QueryHookOptions<QuestionTitleQuery, QuestionTitleQueryVariables> & ({ variables: QuestionTitleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionTitleQuery, QuestionTitleQueryVariables>(QuestionTitleDocument, options);
      }
export function useQuestionTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionTitleQuery, QuestionTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionTitleQuery, QuestionTitleQueryVariables>(QuestionTitleDocument, options);
        }
// @ts-ignore
export function useQuestionTitleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QuestionTitleQuery, QuestionTitleQueryVariables>): Apollo.UseSuspenseQueryResult<QuestionTitleQuery, QuestionTitleQueryVariables>;
export function useQuestionTitleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionTitleQuery, QuestionTitleQueryVariables>): Apollo.UseSuspenseQueryResult<QuestionTitleQuery | undefined, QuestionTitleQueryVariables>;
export function useQuestionTitleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionTitleQuery, QuestionTitleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionTitleQuery, QuestionTitleQueryVariables>(QuestionTitleDocument, options);
        }
export type QuestionTitleQueryHookResult = ReturnType<typeof useQuestionTitleQuery>;
export type QuestionTitleLazyQueryHookResult = ReturnType<typeof useQuestionTitleLazyQuery>;
export type QuestionTitleSuspenseQueryHookResult = ReturnType<typeof useQuestionTitleSuspenseQuery>;
export type QuestionTitleQueryResult = Apollo.QueryResult<QuestionTitleQuery, QuestionTitleQueryVariables>;